import React from 'react'
import { Modal, Form, Input } from 'antd';
import { InputModal } from '../common/InputModal';
import { AddIndustryTypeFormData } from './CreateIndustryTypeFormFields';
const CreateIndustryTypeModal = ({ dataProps }) => {
    const { open, setOpen, actions } = dataProps;
    const [form] = Form.useForm();

    const handleOk = () => {
        form
            .validateFields()
            .then((values) => {
                actions.handleCreateIndustryType(values?.industryType)
                form.resetFields();
                setOpen(false);
            })
            .catch((errorInfo) => {
                console.log('Validation failed:', errorInfo);
            });
    };

    const handleCancel = () => {
        form.resetFields();
        setOpen(false);
    };

    return (
        <div>

            <InputModal
                propsData={{
                    title: "Add Industry Type",
                    data: null,
                    placeholder: "Add Industry Type Here",
                    open: open,
                    onCancel: handleCancel,
                    onOk: handleOk,
                    okText: "Create",
                    formItems: AddIndustryTypeFormData,
                    form: form
                }}
            />
        </div>
    )
}

export default CreateIndustryTypeModal;

